module.exports = __webpack_public_path__ + "img/Kenny.b3402164.png";